import { gql } from 'apollo-angular';

import { articles } from 'article/model/article.fragments';
import { moduleColumns } from 'module/model/column/module-column.fragments';
import { modulePages } from 'module/model/page/module-page.fragments';

export const moduleOption = gql`
	fragment ModuleOption on ModuleOptionOutput {
		label
		value
		groupName
		position
	}
`;

export const moduleI18n = gql`
	fragment ModuleI18n on ModuleI18nOutput {
		name
		title
		locale
		videoId
		description
		suggestionText
		averageDuration
		options {
			...ModuleOption
		}
	}
	${moduleOption}
`;

export const moduleDependency = gql`
	fragment ModuleDependency on ModuleDependencyOutput {
		dependencyId
		moduleId
		type
	}
`;

export const moduleFragment = gql`
	fragment Module on OrganizationModuleOutput {
		id
		type
		phaseId
		moduleId
		position
		sectionId
		hasSettings
		redirectUrl
		organizationId
		linkedGraphsId
		pushOrgModuleId
		updateTimestamp
		isVisibleInPlan
		linkedQuestionsId
		canTriggerAnswersDocument
		averageSpentTime
		averageSpentDays
		localizations {
			...ModuleI18n
		}
		dependencies {
			...ModuleDependency
		}
		columns {
			...ModuleColumns
		}
		pages {
			...ModulePages
		}
		articles {
			...Articles
		}
	}
	${moduleDependency}
	${moduleColumns}
	${modulePages}
	${moduleI18n}
	${articles}
`;

export const modules = gql`
	fragment Modules on OrganizationModuleOutput {
		id
		type
		phaseId
		moduleId
		position
		sectionId
		hasSettings
		redirectUrl
		organizationId
		linkedGraphsId
		pushOrgModuleId
		updateTimestamp
		isVisibleInPlan
		linkedQuestionsId
		canTriggerAnswersDocument
		averageSpentTime
		averageSpentDays
		localizations {
			...ModuleI18n
		}
	}
	${moduleI18n}
`;
